import { Component, OnInit } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { Http } from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageBag, ValidationMessagesService } from 'ng2-custom-validation';
import { Router } from '@angular/router';
import { LocalStorage, SessionStorage } from "angular2-localstorage";
import { PushNotificationsService } from 'angular2-notifications';
import {IMyDpOptions} from 'mydatepicker';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { HeaderBarComponent } from '../header-bar/header-bar.component';

@Component({
  selector: 'app-table-reservation',
  templateUrl: './table-reservation.component.html',
  styleUrls: ['./table-reservation.component.css']
})
export class TableReservationComponent implements OnInit {
    tableForm : FormGroup;
	table:Object={};
	errorMessage:any[]=[];
   newdata=[];
   postData={};
   settings={};
   meridian=true;
   capcharesult:any;
   capcha:any;
	errors: MessageBag = new MessageBag();
  mydate=new Date();
   public myDatePickerOptions: IMyDpOptions = {       
        dateFormat: 'dd.mm.yyyy',
         disableUntil:{year: this.mydate.getFullYear(), month: this.mydate.getMonth() + 1, day: this.mydate.getDate() - 1}
  };

  constructor(private tableService: WebApiObservableService,private fb: FormBuilder,
        private validationMessagesService: ValidationMessagesService, private router: Router,private _pushNotifications: PushNotificationsService,private SettingService: HeaderBarComponent) {
        	 _pushNotifications.requestPermission();
        }

  ngOnInit() {
  this.SettingService.callsettings((data) => {
        this.settings = data;
    });
  	this.tableForm = this.fb.group({
            'booking_person_name': ['', [
                Validators.required
            ]],
            'no_of_guest': ['', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(4)            
            ]],
            'date': ['', [
                Validators.required,           
            ]],
            'time': ['', [
                Validators.required,           
            ]],
            'special_instructions': ['', [
                Validators.required,           
            ]],
            'email': ['', [
                Validators.required,
                Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)               
            ]],
            'phone': ['', [
                Validators.required,
                
            ]],
            'capcha': ['', [
                Validators.required,
                
            ]]

        });
        this.validationMessagesService
            .seeForErrors(this.tableForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });
              $('.spin').addClass('loading');
             /*Calling Api for generating Capcha*/
    this.tableService
            .getCapchaService('/users/generate-random-string')
            .subscribe(
                result => {this.capcharesult = result;  $('.spin').removeClass('loading');},
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );

  }

  OnTableSubmit(){

  if(this.capcharesult === this.capcha){
    $('.spin').addClass('loading');
  this.newdata.push({'tabledata':this.table})
  
  this.postData={
      email:this.newdata[0].tabledata.email,
      booking_person_name:this.newdata[0].tabledata.booking_person_name,
      no_of_guest:this.newdata[0].tabledata.no_of_guest,
      phone:this.newdata[0].tabledata.phone,
      special_instructions:this.newdata[0].tabledata.special_instructions,
      time:this.newdata[0].tabledata.time.hour + ':' + this.newdata[0].tabledata.time.minute,
      date:this.newdata[0].tabledata.date.formatted,
      status:1
    };
  
    this.tableService
            .createService('/table-reservations', this.postData)
            .subscribe(
                result => {                             
                   $('.spin').removeClass('loading');
                    alert('Table Reservation Successful');
                    this.router.navigate(["message"]);
                    let options = {
                      body: "Table Reservation Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                    }
                    let notify = this._pushNotifications.create('Success', options).subscribe( 
                    );
                  },
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );
  }else{
    alert('Wrong Capcha Code Entered');
  }

  
  }

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/table-reservation/table-reservation.component.ts